//The Workspace view navigation modal

import React from 'react';
import MobileNavigationModal from './MobileNavigationModal';
import { SmartNavigationDrawer } from './SmartNavigationDrawer';
import { InjectedFormProps } from 'redux-form';

export const MobileNavigationWorkspace: React.FC<InjectedFormProps> = (
  props
) => {
  return (
    <MobileNavigationModal {...props}>
      <SmartNavigationDrawer />
    </MobileNavigationModal>
  );
};
